import 'jquery';

/**
 * Handle address forms
 */
(function ($) {
  // list of our forms
  var forms = {};

  $('form[data-form]').each(function (i) {

    forms[$(this).data('form')] = $(this);

    $(this).find('[data-toggle-form]').click(function (e) {
      e.preventDefault();
      // hide all
      for (let form in forms) {
        if (!Object.hasOwnProperty.call(forms, form)) {
          continue;
        }
        forms[form].toggle(form === $(this).data('toggle-form'));
      }
      $(document).trigger('plenigo.resize');
    });

    // handle visibility
    if (typeof $(this).data('show') === 'undefined' && i > 0) {
      $(this).hide();
    } else if (typeof $(this).data('show') !== 'undefined' && $(this).data('show') === 0) {
      $(this).hide();
    }

    // sync input
    $(this).on('change', ':input', function () {
      var formName = $(this).closest('form').data('form'),
        regex = new RegExp(/[^[]+\[([^\]]+)./),
        input = $(this),
        name = input.attr('name').replace(regex, '$1'),
        val = input.val();

      // we only can sync text and number at the moment
      if ('string' !== typeof input.attr('type') || input.attr('type').toLowerCase() !== 'text') {
        return true;
      }

      // we do not want to sync empty values
      if (!$.trim(val)) {
        return true;
      }

      // iterate all forms
      for (let form in forms) {
        if (!Object.hasOwnProperty.call(forms, form)) {
          continue;
        }
        // this should be our form
        if (form === formName) {
          continue;
        }
        // looking for our field
        forms[form].find(':input').each(function () {
          if ('string' === typeof $(this).attr('name') && name === $(this).attr('name').replace(regex, '$1')) {
            $(this).val(val).addClass('filled');
          }
        });
      }
    });
  });

}(jQuery));
